import Layout from '@/components/layout';
import { graphql } from 'gatsby';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import Work from '../../node_modules/@kkngsm/works/src/physarum';

type Props = {
  data: GatsbyTypes.IndexQuery;
};
const Canvas = styled.canvas`
  width: 100%;
  height: calc(100vh - 11rem - 5px);
`;
const Home: React.VFC<Props> = ({
  data: {
    site: { siteMetadata },
  },
}) => {
  const ref = useRef<HTMLCanvasElement>();
  useEffect(() => {
    Work.build(ref.current).then((work: any) => {
      work.render(0);
    });
  });
  return (
    <Layout type="top" siteMetadata={siteMetadata}>
      <Canvas ref={ref} />
    </Layout>
  );
};

export const query = graphql`
  query Index {
    site {
      siteMetadata {
        title
        siteUrl
        description
      }
    }
  }
`;
export default Home;
